"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./index.common"), exports);
//# sourceMappingURL=index.browser.js.map